import { render, staticRenderFns } from "./ClaimText.vue?vue&type=template&id=1ff23904&"
import script from "./ClaimText.vue?vue&type=script&lang=js&"
export * from "./ClaimText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports